export default __webpack_public_path__ + "media/zurb/img/legacy/clue/instructions-2-deb9be5caafa31ea37bed884201ec8db.jpg";